import React from 'react';
import PropTypes from 'prop-types';
import Clock from "./Clock";
import {withStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";

const styles = theme => ({
    root: {
        background: ({color}) => `linear-gradient(45deg, ${theme.palette[color].dark} 0%, ${theme.palette[color].main} 100%)`,
        color: theme.palette.common.white,
        padding: [[theme.spacing(4), theme.spacing(4), theme.spacing(2)]],
        borderTopLeftRadius: theme.spacing(2),
        borderTopRightRadius: theme.spacing(2)
    },
});

const Header = ({classes, room, model, status, color, ...props}) => {
    return (
        <div className={classes.root}>
            <Typography variant={"h3"}>{room}</Typography>
            <Typography variant={"h5"}>{model} • Status: {status}</Typography>
        </div>
    );
};

Header.propTypes = {
    room: PropTypes.string.isRequired,
};

export default withStyles(styles)(Header);
